import { CREST } from "@/lib/images";

export function Crest({ className = "", size = 48 }) {
  return (
    <img
      src={CREST}
      alt="Έμβλημα Ρεάλ Δυτικής Αττικής"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
      draggable={false}
    />
  );
}
